import { Flex, Divider } from '@chakra-ui/react';
import React, { useState } from 'react';
import {
  HiOutlineTag,
  HiOutlineShoppingBag,
  HiOutlineUserGroup,
  HiOutlineDocumentText,
  HiOutlineDocumentReport,
  HiOutlineUserAdd,
  HiOutlineLocationMarker,
  HiOutlineIdentification,
} from 'react-icons/hi';
import { IoSettingsOutline } from 'react-icons/io5';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import { FiTarget, FiBarChart2, FiMessageCircle } from 'react-icons/fi';

import { FaColumns, FaChartPie, FaTruck, FaFileSignature } from 'react-icons/fa';

import { SidebarItem } from '../SidebarItem';
import { useAuth } from '../../context/AuthContext';
import { useSidebar } from '../../context/SidebarContext';

const NavFlex = Flex as React.ComponentType<any>;
const NavDivider = Divider as React.ComponentType<any>;

export const SiderbarResponsive = () => {
  const { navSize, setNavSize } = useSidebar();
  const { user } = useAuth();

  return (
    <NavFlex
      zIndex="20"
      pos="fixed"
      top="0px"
      transitionDuration="0.3s"
      transitionTimingFunction="ease-in"
      overflow="hidden"
      h="100vh"
      w={navSize === 'large' ? '65px' : '250px'}
      flexDir="column"
      justify="space-between"
      bg="gray.900"
      border="1px solid"
      borderColor="gray.800"
      as="nav"
      onMouseEnter={() => { setNavSize('small'); }}
      onMouseLeave={() => { setNavSize('large'); }}
    >
      <NavFlex as="aside" flexDir="column" justifyContent="center" mt="100px">

        <SidebarItem name="Assistente ESF" nav={navSize} icon={FiMessageCircle} path="/assistente" />
        <NavDivider w={navSize === 'large' ? '30px' : '220px'} transitionDuration="0.42s" ml={4} />
        <SidebarItem name="Pedidos" nav={navSize} icon={HiOutlineDocumentReport} path="/listar/pedido" />
        <NavDivider w={navSize === 'large' ? '30px' : '220px'} transitionDuration="0.42s" ml={4} />
        <SidebarItem name="Orçamentos" nav={navSize} icon={HiOutlineDocumentText} path="/listar/orcamento" />
        <NavDivider w={navSize === 'large' ? '30px' : '220px'} transitionDuration="0.42s" ml={4} />
        <SidebarItem name="Categorias" nav={navSize} icon={HiOutlineTag} path="/listar/categoria" />
        <SidebarItem name="Produtos" nav={navSize} icon={HiOutlineShoppingBag} path="/listar/produto" />
        <SidebarItem name="Tabela de Preço" nav={navSize} icon={RiMoneyDollarCircleLine} path="/listar/tabela-preco" />
        <NavDivider w={navSize === 'large' ? '30px' : '220px'} transitionDuration="0.42s" ml={4} />
        <SidebarItem name="Clientes" nav={navSize} icon={HiOutlineUserGroup} path="/listar/cliente" />
        <NavDivider w={navSize === 'large' ? '30px' : '220px'} transitionDuration="0.42s" ml={4} />
        <SidebarItem name="Vendedores" nav={navSize} icon={HiOutlineUserAdd} path="/listar/vendedor" />
        <SidebarItem name="Metas" nav={navSize} icon={FiTarget} path="/listar/meta" />
        <SidebarItem name="Painel de Metas" nav={navSize} icon={FiBarChart2} path="/painel/metas" />
        {/* Mapa de Expedição, Kanban e Dashboard são padrão para todas as empresas
            (antes o Mapa dependia de utiliza_opme). O campo utiliza_opme segue
            existindo na parametrização — ainda governa os tipos de pedido em
            CreateRegrasParametrizacao e é lido pelo app Ionic —, só não decide
            mais a visibilidade destes itens.
            A Valeza é um laticínio, não OPME: o nome exibido é "Mapa de Expedição".
            As ROTAS seguem /mapa-cirurgico para não quebrar links já salvos e
            favoritos dos usuários. */}
        <SidebarItem name="Mapa de Expedição" nav={navSize} icon={HiOutlineLocationMarker} path="/mapa-cirurgico" />
        <SidebarItem name="Kanban" nav={navSize} icon={FaColumns} path="/mapa-cirurgico/kanban" />
        <SidebarItem name="Dashboard" nav={navSize} icon={FaChartPie} path="/mapa-cirurgico/dashboard" />
        <SidebarItem name="Em Rota" nav={navSize} icon={FaTruck} path="/entregas" />
        <SidebarItem name="Canhotos" nav={navSize} icon={FaFileSignature} path="/entregas/canhotos" />
        {user?.role === 'ROLE_ADMIN' && (
          <>
            <NavDivider w={navSize === 'large' ? '30px' : '220px'} transitionDuration="0.42s" ml={4} />
            <SidebarItem name="Usuários" nav={navSize} icon={HiOutlineIdentification} path="/listar/usuario" />
            <SidebarItem name="Cadastro Empresas" nav={navSize} icon={IoSettingsOutline} path="/listar/parametrizacao" />
          </>
        )}

      </NavFlex>
    </NavFlex>
  );
};
